
import { MapTo } from '@adobe/aem-react-editable-components';
import ShareModule, { ShareModuleEditConfig } from './ShareModule';

export default MapTo('cob-corp-acquisition/components/creditonebank/share-module')(ShareModule, ShareModuleEditConfig);
        